var $f5e5effd96d66274$exports = {};
const $f5e5effd96d66274$var$targetDate = new Date("June 11, 2026 16:00:00").getTime();
function $f5e5effd96d66274$var$updateCountdown() {
    const now = new Date().getTime();
    const difference = $f5e5effd96d66274$var$targetDate - now;
    if (difference < 0) {
        document.getElementById("days").innerText = "00";
        document.getElementById("hours").innerText = "00";
        document.getElementById("minutes").innerText = "00";
        document.getElementById("seconds").innerText = "00";
        return;
    }
    const days = Math.floor(difference / 86400000);
    const hours = Math.floor(difference % 86400000 / 3600000);
    const minutes = Math.floor(difference % 3600000 / 60000);
    const seconds = Math.floor(difference % 60000 / 1000);
    document.getElementById("days").innerText = days;
    document.getElementById("hours").innerText = hours < 10 ? `0${hours}` : hours;
    document.getElementById("minutes").innerText = minutes < 10 ? `0${minutes}` : minutes;
    document.getElementById("seconds").innerText = seconds < 10 ? `0${seconds}` : seconds;
}
setInterval($f5e5effd96d66274$var$updateCountdown, 1000);
$f5e5effd96d66274$var$updateCountdown();
const $f5e5effd96d66274$var$menuToggle = document.getElementById('menuToggle');
const $f5e5effd96d66274$var$navbarMenu = document.getElementById('navbarMenu');
$f5e5effd96d66274$var$menuToggle.addEventListener('click', ()=>{
    $f5e5effd96d66274$var$navbarMenu.classList.toggle('active');
    const icon = $f5e5effd96d66274$var$menuToggle.querySelector('span');
    if ($f5e5effd96d66274$var$navbarMenu.classList.contains('active')) icon.innerText = 'close';
    else icon.innerText = 'menu';
});


//# sourceMappingURL=path0.5ee965ed.js.map
